// src/app/app.routes.ts
import { Routes } from '@angular/router';

// Standalone components públicos

import { TwoFactorComponent } from './features/admin/user-management/components/two-factor/two-factor.component';
import { AccesoDenegadoComponent } from './features/comun/acceso-denegado/acceso-denegado.component';

// Standalone principal
import { DashboardComponent } from './features/dashboard/dashboard.component';


// Guard
import { authGuard } from './core/guards/auth.guard';
import { HomeComponent } from './features/dashboard/pages/home/home.component';
import { LoginComponent } from './features/admin/auth/pages/login/login.component';

export const routes: Routes = [

    // -----------------------------
    // 🔵 RUTAS PÚBLICAS
    // -----------------------------
    { path: 'login', component: LoginComponent },
    { path: 'two-factor', component: TwoFactorComponent },
    { path: 'acceso-denegado', component: AccesoDenegadoComponent },

    // -----------------------------
    // 🔵 RUTAS PROTEGIDAS
    // -----------------------------
    {
        path: '',
        canActivate: [authGuard],
        component: DashboardComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            { path: 'torneos', loadComponent: () => import('./features/admin/tournaments/tournaments.component').then(m => m.TournamentsComponent) },
            { path: 'torneo', loadComponent: () => import('./features/admin/tournaments/tournaments.component').then(m => m.TournamentsComponent) },
            { path: 'tournaments', loadComponent: () => import('./features/admin/tournaments/tournaments.component').then(m => m.TournamentsComponent) },
            { path: 'admin', loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES) },
            { path: 'nino-shopping', loadChildren: () => import('./features/nino/nino.routes').then(m => m.NINO_ROUTES) },
            { path: 'finanzas', loadChildren: () => import('./features/finanzas/finanzas.routes').then(m => m.FINANZAS_ROUTES) },

            // { path: 'comun', loadChildren: () => import('./features/comun/comun.routes').then(m => m.COMUN_ROUTES) },
            // { path: 'interna', loadChildren: () => import('./features/interna/interna.routes').then(m => m.INTERNA_ROUTES) },
            // { path: 'perimetral', loadChildren: () => import('./features/perimetral/perimetral.routes').then(m => m.PERIMETRAL_ROUTES) },
            // { path: 'informatica', loadChildren: () => import('./features/informatica/informatica.routes').then(m => m.INFORMATICA_ROUTES) }

        ]
    },

    // -----------------------------
    // 🔵 RUTA POR DEFECTO
    // -----------------------------
    { path: '**', redirectTo: 'login' }
];
